import React from 'react';

interface Props {
  groups: React.ReactNode[];
  separatorClassName: string;
}

// 団体会員コードの 3-3-4 グループをハイフン区切りで並べる共通表示。
// 表示用(FormattedOrganizationMembershipCode)と入力用(OrganizationMembershipCodeSplitInput)で
// 区切り描画のロジックを共有し、書式変更時の乖離を防ぐ。区切りのスタイルは利用側から渡す。
const OrganizationMembershipCodeGroups: React.FC<Props> = ({
  groups,
  separatorClassName,
}) => (
  <>
    {groups.map((group, index) => (
      <React.Fragment key={index}>
        {index > 0 && <span className={separatorClassName}>-</span>}
        {group}
      </React.Fragment>
    ))}
  </>
);

export default OrganizationMembershipCodeGroups;
